import { MutationTree } from 'vuex';
import { EDocumentEditMutation, state as initalState } from './document-edit.constants';
import { IDocumentEditState } from './document-edit.types';
import { IRecipient } from '@lib-shared/types/Recipient';
import { IDocument } from '@lib-shared/types/Document';
import { ISender } from '@lib-shared/types/Sender';
import { EnumDocumentType } from '@/enums/DocumentType';

export const mutations: MutationTree<IDocumentEditState> = {
  [EDocumentEditMutation.AddingRecipient](state: IDocumentEditState, payload: boolean) {
    state.isAddingRecipient = payload;
  },
  [EDocumentEditMutation.LoadingRecipients](state: IDocumentEditState, payload: boolean) {
    state.isLoadingRecipients = payload;
  },
  [EDocumentEditMutation.SetRecipients](state: IDocumentEditState, payload: IRecipient[]) {
    state.recipients = payload;
  },
  [EDocumentEditMutation.SetIsSigning](state: IDocumentEditState, payload: boolean) {
    state.isSigning = payload;
  },
  [EDocumentEditMutation.LoadDocumentData](state: IDocumentEditState, payload: boolean) {
    state.isLoadingDocument = payload;
  },
  [EDocumentEditMutation.SetNewType](state: IDocumentEditState, newType: EnumDocumentType) {
    state.documentType = newType;
  },
  [EDocumentEditMutation.InitalizeDocumentEdit](state) {
    Object.keys(state).forEach(key => {
      state[key] = initalState[key];
    });
  },
  [EDocumentEditMutation.SetDocumentData](state: IDocumentEditState, payload: IDocument) {
    state.isSigning = payload.isSigning;
    state.isSigningOrder = payload.isSigningOrder;
    state.isSelfsign = payload.isSelfsign;
    state.documentType = payload.type;
    state.isVideo = payload.isVideo;
    state.videoId = payload.videoId;
    state.id = payload.id || '';
  },
  [EDocumentEditMutation.SetIsSigningOrder](state: IDocumentEditState, payload: boolean) {
    state.isSigningOrder = payload;
  },
  [EDocumentEditMutation.SetIsSelfsign](state: IDocumentEditState, payload: boolean) {
    state.isSelfsign = payload;
  },
  [EDocumentEditMutation.SetSender](state: IDocumentEditState, payload: ISender) {
    state.sender = payload;
  },
  [EDocumentEditMutation.RemoveVideo](state: IDocumentEditState) {
    state.videoId = '';
    state.isVideo = false;
  },
  [EDocumentEditMutation.SetVideo](state: IDocumentEditState, payload: string) {
    state.videoId = payload;
    state.isVideo = true;
  },
  [EDocumentEditMutation.SetDocumentId](state: IDocumentEditState, payload: string) {
    state.id = payload;
  },
  [EDocumentEditMutation.SetActiveTab](state: IDocumentEditState, payload: string) {
    state.activeTab = payload;
  },
  [EDocumentEditMutation.SetError](state: IDocumentEditState, error: boolean) {
    state.error = error;
  },
};
